import type { PageGuide } from "../page-guide.js";

/** Help guide for Board Meetings (centred workflow tour; no anchored panels yet). */
export const boardMeetingsGuide: PageGuide = {
  route: "/board-meetings",
  version: 1,
  overviewArticleId: "board-meetings-overview",
  steps: [
    {
      id: "create",
      title: "Create a meeting",
      body: "Set the title, date, location, and chair, then add agenda sections and link the relevant vault documents.",
    },
    {
      id: "prepare",
      title: "Build the board pack",
      body: "**Take snapshot** → **Generate commentary** → **Generate pack** assembles a PDF board pack from point-in-time financial and operational data.",
    },
    {
      id: "lifecycle",
      title: "Run the lifecycle",
      body: "Meetings move **Draft → Published → In Progress → Completed → Archived**. Open actions carry forward to the next meeting automatically.",
    },
  ],
  panels: [],
  guidedActions: [],
};
